import Vue from 'vue'
import LableResultCanvas from './main.vue'

const LableResultConstructor = Vue.extend(LableResultCanvas)

let instance

const initInstance = (element) => {
  instance = new LableResultConstructor({
    el: document.createElement('div'),
  })
  // element.parentNode.insertBefore(instance.$el, element.nextSibling)
  element.appendChild(instance.$el)
}

const LableResult = function (element) {
  if (!instance) {
    initInstance(element)
    instance.width = element.offsetWidth
    instance.height = element.offsetHeight
    instance.container = element
  }
  return LableResult
}

LableResult.isInstance = function () {
  return !!instance
}

LableResult.init = function (data, left, top, matrix) {
  instance.visible = true
  instance.data = data
  instance.left = left
  instance.top = top
  matrix && (instance.matrix = matrix)
  instance.init()
  return LableResult
}

LableResult.getProducts = function () {
  return instance.canvasData.products
}

LableResult.changeProduct = function (number) {
  instance.selectedProduct = instance.canvasData.productMap[number]
  instance.onProductNumberChange()
}

LableResult.update = function (left, top, matrix) {
  instance.left = left
  instance.top = top
  matrix && (instance.matrix = matrix)
  instance.update()
  return LableResult
}

LableResult.show = function () {
  instance.visible = true
  return LableResult
}

LableResult.hide = function () {
  if (instance) {
    instance.visible = false
  }
  return LableResult
}

LableResult.destroy = function () {
  if (instance) {
    instance.destroy()
    instance = null
  }
  return LableResult
}

LableResult.destroy = () => {
  if (instance) {
    instance.$el.remove()
    instance.$destroy()
    instance = null
  }
}

export default LableResult
export { LableResult }



// WEBPACK FOOTER //
// ./src/views/question-review/components/LableResult/src/main.js